/**
 * Summit Theme Animations
 * Based on Framer Motion analysis - scroll-triggered animations
 */

(function () {
  'use strict';

  // Animation configuration based on Framer specs
  const ANIMATION_CONFIG = {
    threshold: 0.1,
    rootMargin: '0px 0px -10% 0px',
    once: true
  };

  // Initialize Intersection Observer
  const initScrollAnimations = () => {
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all elements immediately
      document.querySelectorAll('[data-animate]').forEach(el => {
        el.classList.add('animate-in');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add animation class to target
          entry.target.classList.add('animate-in');

          // If it's a stagger container, animate children
          if (entry.target.hasAttribute('data-stagger-container')) {
            const children = entry.target.querySelectorAll('[data-stagger-item]');
            children.forEach(child => child.classList.add('animate-in'));
          }

          // Stop observing if once: true
          if (ANIMATION_CONFIG.once) {
            observer.unobserve(entry.target);
          }
        }
      });
    }, {
      threshold: ANIMATION_CONFIG.threshold,
      rootMargin: ANIMATION_CONFIG.rootMargin
    });

    // Observe all elements with data-animate attribute
    document.querySelectorAll('[data-animate]').forEach(el => {
      observer.observe(el);
    });

    // Observe stagger containers
    document.querySelectorAll('[data-stagger-container]').forEach(el => {
      observer.observe(el);
    });
  };

  // Stagger animation initialization
  const initStaggeredAnimations = () => {
    document.querySelectorAll('[data-stagger-container]').forEach(container => {
      const children = container.querySelectorAll('[data-stagger-item]');
      const delay = parseFloat(container.dataset.staggerDelay) || 0.1;

      children.forEach((child, index) => {
        child.style.transitionDelay = `${index * delay}s`;
      });
    });
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initScrollAnimations();
      initStaggeredAnimations();
    });
  } else {
    initScrollAnimations();
    initStaggeredAnimations();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', () => {
    initScrollAnimations();
    initStaggeredAnimations();
  });

  // Failsafe: reveal any still-hidden elements after 3s
  // (covers full-page screenshots, headless browsers, etc.)
  const revealAll = () => {
    document.querySelectorAll('[data-animate]:not(.animate-in)').forEach(el => {
      el.classList.add('animate-in');
    });
    document.querySelectorAll('[data-stagger-item]:not(.animate-in)').forEach(el => {
      el.classList.add('animate-in');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(revealAll, 3000));
  } else {
    setTimeout(revealAll, 3000);
  }

})();
